import { render } from "./StandardHeaderNavContainer.vue?vue&type=template&id=477b7970&scoped=true"
import script from "./StandardHeaderNavContainer.vue?vue&type=script&lang=js"
export * from "./StandardHeaderNavContainer.vue?vue&type=script&lang=js"

import "./StandardHeaderNavContainer.vue?vue&type=style&index=0&id=477b7970&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477b7970"]])

export default __exports__